import React from 'react'
import styled from 'styled-components'
import { ValueTile } from './ValueTile'
import { breakpointFrom, breakpointUpTo } from 'utils/breakpoints'
import { LayoutContentWrapper } from 'components/LayoutContentWrapper/LayoutContentWrapper'
import { IValueItemData } from '../../../graphql/types'
import { StyledDisclaimer } from 'components/Disclaimer/Disclaimer'

const StyledSection = styled.section`
  margin-top: 100px;
  margin-bottom: 100px;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.lg)} {
    margin-top: 72px;
    margin-bottom: 72px;
  }

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    margin-top: 36px;
    margin-bottom: 36px;
  }
`

const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[4]};
  ${({ theme }) => breakpointFrom(theme.breakpoints.md)} {
    flex-direction: row;
  }
`

const StyledListItem = styled.li`
  ${({ theme }) => breakpointFrom(theme.breakpoints.md)} {
    flex-basis: 33.33%;
  }
`

export type SectionValuesListProps = {
  values: IValueItemData[]
  disclaimer?: string
}

export const SectionValuesList = ({
  values,
  disclaimer,
}: SectionValuesListProps) => {
  return (
    <StyledSection>
      <LayoutContentWrapper>
        <StyledList>
          {values.map(({ id, ...props }) => {
            return (
              <StyledListItem key={id}>
                <ValueTile {...props} />
              </StyledListItem>
            )
          })}
        </StyledList>
        {disclaimer && <StyledDisclaimer>{disclaimer}</StyledDisclaimer>}
      </LayoutContentWrapper>
    </StyledSection>
  )
}
